<template>
  <div>
    <md-card class="md-layout-item md-size-50 md-small-size-100">
      <form action="http://binet-expertise.fr/facturation/server/insertSociete.php" method="post">
        <md-card-content v-for="(societe, index) in societes" v-bind:key="index">
          <md-field>
            <label>Dénomination sociale</label>
            <md-input  v-model="societe.denominationSociale" type="text" name="denominationSociale"></md-input>
          </md-field>

          <md-field>
            <label>Adresse</label>
            <md-input v-model="societe.adresse" type="text" name="adresse"></md-input>
          </md-field>

          <md-field>
            <label>Code postal</label>
            <md-input v-model="societe.codePostal" type="text" name="codePostal"></md-input>
          </md-field>

          <md-field>
            <label>Ville</label>
            <md-input v-model="societe.ville" type="text" name="ville"></md-input>
          </md-field>

          <md-field>
            <label>Téléphone</label>
            <md-input v-model="societe.telephone" type="text" name="telephone"></md-input>
          </md-field>

          <md-field>
            <label>Mail</label>
            <md-input v-model="societe.mail" type="text" name="mail"></md-input>
          </md-field>

          <md-field>
            <label>Numéro de SIREN</label>
            <md-input v-model="societe.siren" type="text" name="siren"></md-input>
          </md-field>

          <md-field>
            <label>Capital</label>
            <md-input v-model="societe.capital" type="text" name="capital"></md-input>
          </md-field>

          <md-field>
            <label>Ville Greffe</label>
            <md-input v-model="societe.villeDeGreffe" type="text" name="villeDeGreffe"></md-input>
          </md-field>

          <md-field>
            <label>Numéro de TVA</label>
            <md-input v-model="societe.numeroTVA" type="text" name="numeroTVA"></md-input>
          </md-field>
        </md-card-content>

        <md-card-actions>
          <md-button type="submit" class="md-primary">Enregistrer</md-button>
        </md-card-actions>
      </form>
    </md-card>
  </div>
</template>

<style scoped>
  .md-card.md-theme-default {
      margin: auto;
  }
</style>

<script>
import axios from 'axios';

export default {
  name: "FormSociete",
  
  data: () => ({
    societes: [
      {
        denominationSociale: '',
        adresse: '',
        codePostal: '',
        ville: '',
        telephone: '',
        mail: '',
        siren: '',
        capital: '',
        villeDeGreffe: '',
        numeroTVA: ''
      }
    ]
  }),

  created() {
    axios.get(`http://binet-expertise.fr/facturation/server/selectSociete.php`)
    .then(response => {
      this.societes = response.data
      console.log(response.data)
    })
    .catch(e => {
      console.log(e)
    })
  }  
};
</script>